// Thin summary bar between the category filter row and the grid.
// Shows `X of Y items` when any filter is active, `Y items` at rest.
// Count mirrors MarketplaceGrid's children projection so the number
// matches what's actually rendered (see `resultsCountLabel` →
// `matchesFilters`).

export const MarketplaceResultsBar = {
  flow: 'x',
  align: 'center',
  gap: 'Z',
  padding: 'Y A',
  borderBottom: '1px solid line',
  // Chip wrap on narrow viewports so the bar doesn't force horizontal
  // scroll when many filters are active.
  flexWrap: 'wrap',

  ResultsCountText: {
    tag: 'span',
    text: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return el.call('resultsCountLabel', host)
    },
    fontSize: 'Y',
    color: 'caption'
  },

  // Active-filter summary. Each chip is dismissable — click × (or
  // anywhere on the chip) to remove that filter. See
  // `activeFilterChips` + `removeFilterChip` in functions/index.js.
  ActiveChipList: {
    flow: 'x',
    align: 'center',
    gap: 'Y',
    flexWrap: 'wrap',
    children: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return el.call('activeFilterChips', host)
    },
    childExtends: 'MarketplaceFilterChip'
  }
}
